import { CatchFilters } from '../../../../components/Maps/types/types';

interface ISpeciesProps {
  saltwater: number;
  freshwater: number;
}

export const getWaterType = (species: ISpeciesProps): string => {
  if (species.freshwater) {
    return 'fresh';
  }
  if (species.saltwater) {
    return 'salt';
  }
  return '';
};

export const getFilterCount = (catchFilters: CatchFilters): number => {
  const count: number[] = [];
  Object.values(catchFilters).forEach(filterList => count.push(filterList.length));
  return count.reduce((current, prev) => current + prev, 0);
};
